import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LeadDataObject, LeadsDataAction } from '../../../../../models/leads/leads.model';
import { Router } from '@angular/router';
import { ActionHelper } from '../../../../../helper/action.helper';
import { LEADS_DATA_SERVICE, LeadsDataService } from '../../../../../services/leads/leads-data.service';
import { ActionIconHelper } from '../../../../../helper/action-icon.helper';

@Component({
  selector: 'fi-table-popup',
  templateUrl: './table-popup.component.html',
  styleUrls: ['./table-popup.component.scss'],
  standalone: false,
})
export class TablePopupComponent implements OnChanges {
  @Input() lead?: LeadDataObject;
  @Input() externalEmail: string;
  @Input() read: boolean;
  @Input() suggestedAction: LeadsDataAction;
  @Input() isDuplicateLead: boolean;
  @Input() isRotateScreen: boolean;
  @Input() leadId: number;

  @Output() closeModal = new EventEmitter();

  @Output() markAsRead = new EventEmitter<number>();
  @Output() openLeadDetail = new EventEmitter<number>();
  @Output() openLeadDetailNewTab = new EventEmitter<number>();
  @Output() markAsUnread = new EventEmitter<number>();
  @Output() isLoaded = new EventEmitter<boolean>();
  @Output() showActions = new EventEmitter<boolean>();
  // loadedLeadComposerOffers: LeadComposerChangesModel[];
  actionHelper = ActionIconHelper;
  actions: LeadsDataAction[] = [];
  showContent = false;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    @Inject(LEADS_DATA_SERVICE) private leadDataService: LeadsDataService,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes.leadId?.currentValue && !this.isDuplicateLead) {
      this.leadDataService.getActionsById(this.leadId).subscribe(({ success, data }) => {
        if (success) {
          this.actions = data;

          if (!!data) {
            this.showContent = true;
            this.showActions.emit(this.showContent);
          }
        }
      });
    } else if (this.isDuplicateLead) {
      this.actions = [];
      this.showContent = true;
      this.showActions.emit(this.showContent);
    }

  }

  closeOverlay(): void {
    this.closeModal.emit();
  }

  openLinkedDialog(label: string): void {
    const actionData = {
      label,
      leadDetails: this.lead,
      contactDetails: this.lead.Contact,
    };
    ActionHelper.showAction('FI-LINK', this.dialog, actionData).afterClosed().subscribe(returnVal => {
      if ( returnVal ) {
        this.actions.splice(this.actions.findIndex(item => item.Name === 'LEAD_CONNECT'), 1);
        ActionHelper.reloadLeadsTable(this.router);
        this.closeOverlay();
      }
    });
  }

  onBtnClick(action: LeadsDataAction): void {
    if (action.Name === 'LEAD_CONNECT') {
      this.openLinkedDialog(action.Label);
      return;
    }

    const actionData = this.getData(action);
    ActionHelper.showAction(action.Name, this.dialog, actionData)?.afterClosed().subscribe(value => {
      if (value === 'remove') {
        // @ts-ignore
        this.actions.splice(this.actions.findIndex(item => item.Name === name), 1);
        ActionHelper.reloadLeadsTable(this.router);
        this.closeOverlay();
      }
    });
  }

  onDuplicateBtnClick(onSuccess?: () => void): void {
    const actionData = { leadId: this.lead?.Id };

    ActionHelper.showAction('DUPLICATE-CHECK', this.dialog, actionData)?.afterClosed().subscribe(value => {
      if (value === 'solved') {
        if (onSuccess) {
          onSuccess?.();
          return;
        }

        ActionHelper.reloadLeadsTable(this.router);
        this.closeOverlay();
      }
    });
  }

  emitOpenDetail(newTab = false): void {
    if (newTab) {
      this.openLeadDetailNewTab.emit(this.lead.Id);
    } else {
      this.openLeadDetail.emit(this.lead.Id);
    }
  }

  emitMarkAsRead(): void {
    this.markAsRead.emit(this.lead.Id);
  }

  emitMarkAsUnread(): void {
    this.markAsUnread.emit(this.lead.Id);
  }

  private getData(action: LeadsDataAction): any {
    return {
      title: action?.Label,
      contactName: this.lead.Contact?.FirstName + ' ' + this.lead.Contact?.LastName,
      leadId: this.lead?.Id,
      leadTypeId: this.lead?.LeadTypeId,
      externalEmail: this.externalEmail,
      // loadedLeadComposerOffers: this.loadedLeadComposerOffers
    };
  }
}
